module.exports = __webpack_public_path__ + "img/postagram_iphone_x_banner.d5792fa1.png";